"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableMenuItem = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var inversify_react_1 = require("inversify-react");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./EditableMenuItem.css"));
var NavigationStore_1 = __importDefault(require("./NavigationStore"));
exports.EditableMenuItem = (0, mobx_react_1.observer)(function (_a) {
    var blockId = _a.blockId, children = _a.children;
    var navigationStore = (0, inversify_react_1.useInjection)(NavigationStore_1.default);
    var item = navigationStore.itemById(blockId);
    var inputRef = (0, react_1.useRef)();
    var _b = __read((0, react_1.useState)(false), 2), isEditing = _b[0], setIsEditing = _b[1];
    (0, react_1.useEffect)(function () {
        if (isEditing) {
            inputRef.current.focus();
        }
    }, [isEditing]);
    return (react_1.default.createElement("div", { className: styles.wrapper({ show: item.show }) }, !isEditing ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles.childrenContainer }, children),
        react_1.default.createElement("div", { className: styles.actions },
            react_1.default.createElement(kaleidoscope_1.IconButton, { className: styles.actionButton, icon: react_1.default.createElement(icons_1.Edit, null), tooltip: { content: "Edit name" }, onClick: function () {
                    setIsEditing(true);
                } }),
            react_1.default.createElement(kaleidoscope_1.IconButton, { className: styles.actionButton, icon: react_1.default.createElement(icons_1.Preview, null), tooltip: { content: item.show ? "Hide" : "Show" }, onClick: function () {
                    (0, mobx_1.runInAction)(function () {
                        item.show = !item.show;
                    });
                } })))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(kaleidoscope_2.TextInput, { ref: inputRef, label: "Block name", labelHidden: true, className: styles.nameInput, value: item.name, placeholder: item.defaultLabel, onBlur: function () {
                setIsEditing(false);
            }, onKeyDown: function (e) {
                if (e.key === kaleidoscope_2.KeyType.Enter) {
                    e.preventDefault();
                    setIsEditing(false);
                }
            }, onChange: function (value) {
                (0, mobx_1.runInAction)(function () {
                    item.name = value;
                });
            } }),
        react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Tick, null), onClick: function () {
                setIsEditing(false);
            } })))));
});
